import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenVideoPreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-video-preview-data.interface';
import { VideoFormat } from '../../../../../../../utils/youtube-format-helper';
import { YoutubeShortsAdDesktopShellComponent } from './youtube-shorts-ad-desktop-shell.component';

/**
 * Shorts ad for the 1:1 creative: centred square with the player's own black
 * above and below — on desktop the bands stay plain, unlike the blurred copy
 * the phone player paints.
 */
@Component({
    selector: 'app-gen-youtube-shorts-ad-desktop-square',
    imports: [YoutubeShortsAdDesktopShellComponent],
    template: '<app-gen-youtube-shorts-ad-desktop-shell [data]="data" [format]="format" />',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class YoutubeShortsAdDesktopSquarePreviewComponent {
  @Input() data!: GenVideoPreviewData;

  readonly format: VideoFormat = '1:1';
}
